import React, {useCallback, useContext, useState} from 'react';
import {WizardContext} from "../Wizard";
import {CHANGE_SUB_OPTION_DATA, SET_MIN_AND_MAX_PRICE} from "../../WizardConstants";

export function WizardFormSubSelect({data, selectedIdx}) {
    const {dispatch} = useContext(WizardContext);
    const [optionDescription, setOptionDescription] = useState('');

    const onChange = useCallback((e) => {
        const selectedOption = data.suboption.find(item => item.idx === parseInt(e.target.value))
        dispatch({
            type: CHANGE_SUB_OPTION_DATA,
            dataName: e.currentTarget.name,
            optionName: selectedOption.name,
            optionValue: selectedOption.idx,
            price_min: selectedOption.price_min,
            price_max: selectedOption.price_max,

        })
        setOptionDescription(selectedOption.description);

        dispatch({
            type: SET_MIN_AND_MAX_PRICE,
        })
    }, [dispatch, data]);

    return (
        data.idx === parseInt(selectedIdx) &&
        <div className="form-group">
            <select name={data.name}
                    className="form-control form-control-solid form-control-lg" onChange={onChange}>
                <option value>Select</option>
                {
                    data.suboption.map((wizardOptionData, i) => {
                        return (<option value={wizardOptionData.idx}
                                        key={"suboptions-" + i}>{wizardOptionData.name}</option>)
                    })
                }
            </select>
            {(optionDescription !== undefined && optionDescription.length) > 0 ?
            <span className="btn btn-md bg-white-o-15 mr-4">
              <i className="flaticon2-shopping-cart-1 text-success"></i>
              {optionDescription}
            </span> : ''}
        </div>
    )
}
